// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Kdzm","footer":"ModalCreateQualiphyProcedure_footer__2vu3C","additionData":"ModalCreateQualiphyProcedure_additionData__2P8nL"};